import React from "react";

const BikeAndRide = ({ title, ...props }) => (
  <svg
    id="bike_and_ride_svg__Layer_2_1_"
    x={0}
    y={0}
    viewBox="0 0 390 390"
    xmlSpace="preserve"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <style>{".bike_and_ride_svg__st0{fill:#010101}"}</style>
    <path
      className="bike_and_ride_svg__st0"
      d="M390 121.7L195 41.4 0 121.7v32.2l24.4-10v184.8h341.3V143.8l24.4 10v-32.1zm-51.5 179.8h-287V132.6l143.5-59 143.5 59v168.9z"
    />
    <path
      className="bike_and_ride_svg__st0"
      d="M165.7 151.4H144c-3 0-5.5-2.4-5.5-5.5s2.4-5.5 5.5-5.5h21.7c3 0 5.5 2.4 5.5 5.5-.2 3.1-2.6 5.5-5.5 5.5z"
    />
    <path
      className="bike_and_ride_svg__st0"
      d="M272.4 181.1c-6.4 0-12.6 1.3-18.2 3.6-1.7-4.1-2.9-7.6-3.9-10.1v-.1l-15.9-42.4c-.8-2.1-2.8-3.5-5.1-3.5h-21c-3 0-5.5 2.4-5.5 5.5s2.4 5.5 5.5 5.5h17.2l6.7 17.9h-72.8c-2 0-3.6 1-4.6 2.5l-16.7 26.1c-6.3-3.1-13.5-4.9-21.1-4.9-26.5 0-48.1 21.5-48.1 48.1s21.5 48.1 48.1 48.1c24.8 0 45-18.6 47.8-42.6h19.5c1.6 0 3-.7 4-1.8l52.2-53.3c.7 2 2.1 5.7 4 10.4-12.3 8.7-20.3 23-20.3 39.2 0 26.5 21.5 48.1 48.1 48.1 26.5 0 48.1-21.5 48.1-48.1.1-26.6-21.5-48.2-48-48.2zm-129 74.4c-7 7-16.4 10.9-26.3 10.9s-19.3-3.9-26.3-10.9-10.9-16.4-10.9-26.3c0-9.9 3.9-19.3 10.9-26.3s16.4-10.9 26.3-10.9 19.3 3.9 26.3 10.9c5.8 5.8 9.4 13 10.5 20.9H117c-3 0-5.5 2.4-5.5 5.5s2.4 5.5 5.5 5.5h37c-1.2 7.8-4.9 15-10.6 20.7zm21.5-31.7c-1.5-12.9-8-24.2-17.6-32l10.8-17 18.4 48.9-11.6.1zm21.5-4.5l-19.2-51.1h69.1l.1.1-50 51zm112.3 36.2c-7 7-16.4 10.9-26.3 10.9-9.9 0-19.3-3.9-26.3-10.9s-10.9-16.4-10.9-26.3c0-9.9 3.9-19.3 10.9-26.3.9-.9 1.9-1.8 2.8-2.5v.1c7.2 16.2 13.8 27.2 19.7 32.8 1.1 1 2.4 1.5 3.7 1.5 1.5 0 2.9-.6 4-1.7 2-2.1 1.9-5.7-.2-7.7-5.9-5.5-12.5-18.5-17.7-30.5 4.4-1.8 9.2-2.7 14-2.7 9.9 0 19.3 3.9 26.3 10.9s10.9 16.4 10.9 26.3c.1 9.8-3.8 19.1-10.9 26.1z"
    />
  </svg>
);

export default BikeAndRide;
